import axios from "axios";
import store from "../../store/index.js"  //引用store
import { Indicator ,MessageBox} from 'mint-ui';
const Axios = axios.create({
  baseURL: "", // 因为我本地做了反向代理
  timeout: 60000,
  responseType: "json",
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    'Content-Type':'application/x-www-form-urlencoded',
    'X-Requested-With':'XMLHttpRequest',
    // "BankId": "9999",
    // "LoginType": "P",
    // "_locale": "zh_CN",
    // "_ChannelId": "PMBS"
  }
});
// 添加请求拦截器
Axios.interceptors.request.use(function(config) {
	// 在发送请求之前做些什么 设置token 判断有没有token
	if (store.state.token) {
		config.headers.token = `${store.state.token}`;
		// config['headers']['Authorization'] = AUTH_TOKEN
  }
  Indicator.open('加载中...');
  // this.$alert('服务器通讯异常或网络连接失败!',{
  //   title: '提示',
  // });
	return config;
}, function(error) {
  Indicator.close();
  // 对请求错误做些什么
	return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
Axios.interceptors.response.use( 
  response => {
    if(response.status=200){
      Indicator.close();
      if(response.data._RejCode==="000000"){
        return Promise.resolve(response);
      }else{
        MessageBox({
          title: '提示',
          message:response.data.errmsg
        });
        return Promise.reject(response);
      }
    }else{
      Indicator.close();
      MessageBox({
        title: '提示',
        message:'服务器通讯异常或网络连接失败!'
      });
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '错误请求'
          break;
        case 401:
          error.message = '未授权，请重新登录'
          break;
        case 403:
          error.message = '拒绝访问'
          break;
        case 404:
          error.message = '请求错误,未找到该资源'
          break;
        case 405:
          error.message = '请求方法未允许'
          break;
        case 408:
          error.message = '请求超时'
          break;
        case 500:
          error.message = '服务器端出错'
          break;
        case 501:
          error.message = '网络未实现'
          break;
        case 502:
          error.message = '网络错误'
          break;
        case 503:
          error.message = '服务不可用'
          break;
        case 504:
          error.message = '网络超时'
          break;
        case 505:
          error.message = 'http版本不支持该请求'
          break;
        default:
          error.message = `连接错误${error.response.status}`
      }
    } else {
      Indicator.close();
      error.message = "连接到服务器失败"
    }
    MessageBox({
      message: error.message
    });
    // // 返回 response 里的错误信息
    // let errorInfo = error.response ? error.response : error.message
    // return Promise.reject(errorInfo);
  }
);

// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, "$axios", {
      value: Axios
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/axios/index.js